const styles = {
    eventNotFount: "mt-2 text-xl font-bold tracking-tight bg-gradient-to-r text-transparent bg-clip-text from-blue-400 to-green-500 text-gray-900",
    p: "font-semibold text-xl text-gray-900 dark:text-white border-b-[3px] p-2",
    exito: "text-sm text-lime-400"
}
export default styles